module.exports = __webpack_public_path__ + "static/media/loading.7b38720a.gif";